<template>
  <div class="main-content">
    <!-- 搜索区域 -->
    <el-form :inline="true" :model="queryParams" class="demo-form-inline">
      <el-form-item label="煤源名称">
        <el-input v-model="queryParams.cocalName" placeholder="请输入煤源名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="热值区间">
        <el-input-number v-model="queryParams.startCocalHots" :min="0" placeholder="起始值" :controls="false" style="width: 120px;"></el-input-number>
        <span style="margin: 0 5px;">-</span>
        <el-input-number v-model="queryParams.endCocalHots" :min="0" placeholder="结束值" :controls="false" style="width: 120px;"></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格区域 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="cocalName" label="煤源名称" align="center"></el-table-column>
      <el-table-column prop="cocalPrice" label="煤源价格" align="center"></el-table-column>
      <el-table-column prop="cocalHots" label="煤源热值" align="center"></el-table-column>
      <el-table-column prop="cocalStock" label="煤源库存" align="center"></el-table-column>
      <el-table-column prop="cocalLiufen" label="煤源硫分" align="center"></el-table-column>
      <el-table-column prop="cocalImg" label="煤源图片" align="center">
        <template slot-scope="scope">
          <img :src="url+'upload/'+scope.row.cocalImg" style="width:150px;height:150px" v-if="scope.row.cocalImg">
          <span v-else>用户未上传封面</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryParams.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="煤源名称" prop="cocalName">
          <el-input v-model="form.cocalName"></el-input>
        </el-form-item>
        <el-form-item label="煤源价格" prop="cocalPrice">
          <el-input-number v-model="form.cocalPrice"  :controls="false" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="煤源热值" prop="cocalHots">
          <el-input-number v-model="form.cocalHots" :step="100" :controls="false" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="煤源库存" prop="cocalStock">
          <el-input-number v-model="form.cocalStock" :step="100" :controls="false" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="煤源硫分" prop="cocalLiufen">
          <el-input-number v-model="form.cocalLiufen" :precision="2" :step="0.01" :controls="false" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="煤源图片" prop="cocalImg">
          <el-upload
            class="cocal-img-uploader"
            :action="fileUploadUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="form.cocalImg" :src="url + 'upload/' + form.cocalImg" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="煤源内容" prop="cocalMes">
          <editor v-model="form.cocalMes" :min-height="192"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import base from '../../../utils/base';
import editor from '@/components/common/Editor'
export default {
  components: {
    editor
  },
  data() {
    return {
      url: base.get().url,
      fileUploadUrl: base.get().fileUploadUrl,
      queryParams: {
        page: 1,
        limit: 10,
        cocalName: '',
        startCocalHots: undefined,
        endCocalHots: undefined,
        sort: 'id',
        order:'desc'
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      dialogTitle: '',
      loading: false,
      form: {
        cocalName: '',
        cocalPrice: 0,
        cocalHots: 0,
        cocalLiufen: 0,
        cocalStock: 0,
        cocalImg: '',
        cocalMes: '',
        id: null,
      },
      rules: {
        cocalName: [
          { required: true, message: '请输入煤源名称', trigger: 'blur' }
        ],
        cocalPrice: [
          { required: true, message: '请输入煤源价格', trigger: 'blur' }
        ],
        cocalHots: [
          { required: true, message: '请输入煤源热值', trigger: 'blur' }
        ],
        cocalLiufen: [
          { required: true, message: '请输入煤源硫分', trigger: 'blur' }
        ],
        cocalStock: [
          { required: true, message: '请输入煤源库存', trigger: 'blur' }
        ],
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      this.$http({
        url: "cocalSale/page",
        method: 'get',
        params: this.queryParams
      }).then(({data}) => {
        this.loading = false;
        if (data && data.code === 0) {
          this.tableData = data.data.list;
          this.total = data.data.totalCount;
        } else {
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleReset() {
      this.queryParams = {
        page: 1,
        limit: 10,
        cocalName: '',
        startCocalHots: undefined,
        endCocalHots: undefined
      };
      this.getList();
    },
    handleAdd() {
      this.dialogTitle = '新增在售煤源';
      this.form = {
        cocalName: '',
        cocalPrice: 0,
        cocalHots: 0,
        cocalLiufen: 0,
        cocalImg: '',
        cocalMes: ''
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs['form'].clearValidate();
      });
    },
    handleEdit(row) {
      this.dialogTitle = '编辑在售煤源';
      this.form = {
        cocalName: row.cocalName,
        cocalPrice: row.cocalPrice,
        cocalHots: row.cocalHots,
        cocalLiufen: row.cocalLiufen,
        cocalImg: row.cocalImg,
        cocalMes: row.cocalMes,
        id: row.id
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs['form'].clearValidate();
      });
    },
    handleDelete(row) {
      this.$confirm('确定要删除该在售煤源吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: "cocalSale/delete",
          method: 'post',
          data: [row.id]
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getList();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      }).catch(() => {});
    },
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log(this.form);
          this.$http({
            url: this.form.id === '' ||this.form.id === null || this.form.id === undefined ? this.url + `cocalSale/` + "save" : this.url + `cocalSale/` + "update",
            method: 'post',
            data: this.form
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false;
                  this.getList();
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 0) {
        this.form.cocalImg = res.file;
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isJPG && isLt2M;
    }
  }
};
</script>

<style lang="scss" scoped>
    .main-content {
        background: #fff;
        border-radius: 6px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    .pagination-container {
        margin-top: 20px;
        text-align: right;
    }

    .cocal-img-uploader .el-upload {
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        transition: border-color 0.25s;
    }

    .cocal-img-uploader .el-upload:hover {
        border-color: var(--publicMainColor);
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
        border-radius: 6px;
        object-fit: cover;
    }

    .el-table img {
        border-radius: 6px;
        object-fit: cover;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .el-table__body tr:hover > td {
        background-color: rgba(58, 110, 165, 0.06) !important;
    }
</style>
